import store from '@/store'

const TOOL = {
  getCurrentTime () {
    const date = new Date()
    const year = date.getFullYear()
    const month = this.repair(date.getMonth() + 1)
    const day = this.repair(date.getDate())
    const hour = this.repair(date.getHours())
    const minute = this.repair(date.getMinutes())
    const second = this.repair(date.getSeconds())
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
  },
  getCurrentDate () {
    const date = new Date()
    const year = date.getFullYear()
    const month = this.repair(date.getMonth() + 1)
    const day = this.repair(date.getDate())
    return year + '-' + month + '-' + day
  },
  repair (i) {
    if (i >= 0 && i <= 9) {
      return '0' + i
    } else {
      return i
    }
  },
  textMore (t, l) {
    if (t && t.length >= l) {
      return t.substr(0, l - 1) + '...'
    } else {
      return t
    }
  },
  compareDate (start, end) {
    if (start == null || start.length === 0 || end == null || end.length === 0) {
      return 0
    }

    const arr = start.split('-')
    const starttime = new Date(arr[0], parseInt(arr[1] - 1), arr[2])
    const starttimes = starttime.getTime()

    const arrs = end.split('-')
    const endtime = new Date(arrs[0], parseInt(arrs[1] - 1), arrs[2])
    const endtimes = endtime.getTime()

    const intervalTime = endtimes - starttimes

    return ((intervalTime).toFixed(2) / 86400000) + 1
  },
  formatFilePath (url) {
    if (url) {
      return store.state.rootUrl + url
    }
    return ''
  },
  formatObjPath (obj) {
    if (obj) {
      return JSON.parse(obj).path
    }
  },
  formatDateTime (value) {
    if (!value) {
      return ''
    }
    const a = new Date(value).getTime()
    const date = new Date(a)
    const Y = date.getFullYear() + '-'
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '  '
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return Y + M + D + h + m + s
  },
  formatDate (value) {
    if (!value) {
      return ''
    }
    const a = new Date(value).getTime()
    const date = new Date(a)
    const Y = date.getFullYear() + '-'
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    return Y + M + D
  },
  exportCsv (tableData, fileName) {
    // encodeURIComponent解决中文乱码
    const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(tableData.join('\r\n'))
    // 通过创建a标签实现
    const link = document.createElement('a')
    link.href = uri
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  removeHTMLTags (str) {
    return str.replace(/<[^>]*>/g, '').replaceAll('&nbsp;', '')
  },
  formatFileSize (fileSize) {
    if (fileSize < 1024) {
      return fileSize + 'B'
    } else if (fileSize < (1024 * 1024)) {
      let temp = fileSize / 1024
      temp = temp.toFixed(2)
      return temp + 'KB'
    } else if (fileSize < (1024 * 1024 * 1024)) {
      let temp = fileSize / (1024 * 1024)
      temp = temp.toFixed(2)
      return temp + 'MB'
    } else {
      let temp = fileSize / (1024 * 1024 * 1024)
      temp = temp.toFixed(2)
      return temp + 'GB'
    }
  },
  secondsToHms (d) {
    d = Number(d)
    const h = Math.floor(d / 3600)
    const m = Math.floor(d % 3600 / 60)
    const s = Math.floor(d % 3600 % 60)

    const hDisplay = h > 0 ? h + (h > 1 ? ' 小时 ' : ' 小时 ') : ''
    const mDisplay = m > 0 ? m + (m > 1 ? ' 分 ' : ' 分 ') : ''
    const sDisplay = s > 0 ? s + (s > 1 ? ' 秒' : ' 秒') : '0秒'
    return hDisplay + mDisplay + sDisplay
  }
}
export default TOOL
